export default {
  "name": "NCRow",
  "column": 1,
  "canAppend": true,
  "type": 1,
  "path": "LowCodeComponents.NCRow",
  "label": "行容器",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "className": {
        "title": "className",
        "description": "组件根元素",
        "type": "string"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}